import DOMPurify from "dompurify";
import moment from "moment";
import "moment-duration-format";

export namespace StringUtils {
  export function checkStringIsEmptyAfterTrimming(string: string): boolean {
    return string.trim().length === 0;
  }

  export function convertToHoursMinutes(value: string): string {
    return moment.duration(value, "hour").format("hh:mm", { trim: false });
  }

  /**
   * Sanitizes an input HTML string to use in dangerouslySetInnerHTML to prevent XSS
   * @param {string} html - The  string to sanitize
   * @returns An object { __html: string }
   */
  export function sanitizeHTML(html: string): { __html: string } {
    return { __html: DOMPurify.sanitize(html) };
  }

  export const DOT_SEPARATOR = "\u00A0•\u00A0";
}
